const MAX_EDGE = 1600;
const QUALITY = 0.82;
const MAX_INPUT_BYTES = 15 * 1024 * 1024;

// Downscales client-side so a 4MB phone screenshot uploads as ~200KB. Returns
// { base64, mimeType } — base64 without the data: prefix, which is what the
// server expects.
export function downscaleImage(file) {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith("image/")) {
      return reject(new Error("הקובץ אינו תמונה"));
    }
    if (file.size > MAX_INPUT_BYTES) {
      return reject(new Error("התמונה גדולה מדי (מקסימום 15MB)"));
    }

    const url = URL.createObjectURL(file);
    const img = new Image();

    img.onload = () => {
      URL.revokeObjectURL(url);
      try {
        const scale = Math.min(1, MAX_EDGE / Math.max(img.width, img.height));
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(img.width * scale);
        canvas.height = Math.round(img.height * scale);

        const ctx = canvas.getContext("2d");
        // JPEG has no alpha — without this, transparent PNG areas turn black.
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        const dataUrl = canvas.toDataURL("image/jpeg", QUALITY);
        resolve({ base64: dataUrl.split(",")[1], mimeType: "image/jpeg", preview: dataUrl });
      } catch {
        reject(new Error("לא ניתן לעבד את התמונה"));
      }
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      // Desktop Chrome can't decode HEIC, which is what iPhone photos often are.
      reject(new Error("פורמט תמונה לא נתמך, נסה JPG או PNG"));
    };

    img.src = url;
  });
}
